import _ from 'lodash';

import {
  EventProtocol,
  TransformProtocol,
} from '@/pages/Vaccination/components/task/types';

export const groupProtocolsByDivision = (
  protocols?: EventProtocol[],
): TransformProtocol[] => {
  if (!protocols) return [];

  const grouped = _.groupBy(protocols, 'structuralDivisionId');

  return Object.entries(grouped).map(([divisionId, items]) => {
    return {
      structuralDivisionId: divisionId,
      events: items,
    };
  });
};

export const filterByInventoryNumber = (
  groupsData: ReturnType<typeof groupProtocolsByDivision>,
  searchValue: string,
) => {
  if (!searchValue.trim()) return groupsData;

  const normalizedSearch = searchValue.trim().toLowerCase();

  const matchingOrderNumbers: Record<string, number[]> = {};

  groupsData?.forEach((group) => {
    group.events?.forEach((event) => {
      event.individuals.forEach((individual) => {
        if (individual?.inventoryNumber?.toLowerCase().includes(normalizedSearch)) {
          if (!matchingOrderNumbers[event.id]) {
            matchingOrderNumbers[event.id] = [];
          }
          matchingOrderNumbers[event.id].push(individual.orderNumber);
        }
      });
    });
  });

  if (Object.keys(matchingOrderNumbers).length === 0) {
    return [];
  }

  return groupsData
    ?.map((group) => ({
      ...group,
      events: group.events
        ?.map((event) => ({
          ...event,
          individuals: event.individuals?.filter((individual) =>
            matchingOrderNumbers[event.id]?.includes(individual?.orderNumber),
          ),
        }))
        .filter((event) => event.individuals && event.individuals.length > 0),
    }))
    .filter((group) => group.events && group.events.length > 0);
};

export const getNameFromEventProtocols = (events: EventProtocol[]): string => {
  if (!Array.isArray(events) || events.length === 0) {
    return '';
  }

  const event: EventProtocol = events?.[0];
  return event?.structuralDivision?.name || event?.structuralDivisionId;
};
